<template>
  <div :class="style">
    <img :src="badgeImage.src" :height="badgeImage.height" :width="badgeImage.width" :title="badgeImage.tooltip" @click.stop="showPopup"/>
    <div v-show="popupVisible">
      <div class="d-flex flex-column innerpopup ">
        <div class="f13-l16-l">{{ badgeImage.tooltip  }}</div>
      </div>
    </div>
    <BGClickCatcherComponent v-show="popupVisible" @click="showPopup" />
  </div>
</template>
<script>
import BGClickCatcherComponent from "@/components/popup/BGClickCatcherComponent";

export default {
  components: {
    BGClickCatcherComponent
  },
  data() {
    return {
      popupVisible: false,
      showit: false
    }
  },
  props: {
    badgeImage: Object,
    variant: {
      type: String,
      default: ""
    }
  },
  computed: {
    style() {
      
      if (this.variant == "cook-view") {
        var style = this.$isMobile() ? "pointer " : "";
        return style + "position-cook-view";
      }

      return "position-default";
    }
  },
  methods: {
    showPopup(event) {
      event.preventDefault();
      if (this.$isMobile() || this.$isTablet()) {
        this.popupVisible = !this.popupVisible;
      }
    },
  }
}
</script>
<style scoped>
.innerpopup {
  z-index: 4000;
  background: white;
  position: absolute;
  right: 0;
  top: 25px;
  border: 1px solid #ccc;
  padding: 5px 5px;
  white-space: wrap !important;
}

@media (max-width: 768px){
  .position-default {
    position: absolute;
    bottom: -15px;
    left: 0px;
  }
  .position-cook-view {
    position: absolute;
    bottom: 0px;
    left: 0px;
  }
}

@media (min-width: 768px) and (max-width: 1200px) {
  .position-default {
    position: absolute;
    bottom: -15px;
    left: 0px;
  }
  .position-cook-view {
    position: absolute;
    bottom: 0px;
    left: 0px;
  }

}

@media (min-width: 1200px) {
  .position-default {
    position: absolute;
    bottom: -15px;
    left: 0px;
  }
  .position-cook-view {
    position: absolute;
    top: 350px;
    left: 0px;
  }

}
  
  </style>
